// The CC0 photo textures under the painted materials (public/assets/textures, fetched by
// scripts/fetch-textures.mjs). They load in the background: a material paints itself with flat
// colour first and again when its photos arrive, so nothing waits for the network.

const cache = new Map(); // name -> { image, ready, promise }

export function photo(name) {
  let p = cache.get(name);
  if (p) return p;
  const image = new Image();
  p = { image, ready: false, promise: null };
  p.promise = new Promise((resolve) => {
    image.onload = () => {
      p.ready = true;
      resolve(image);
    };
    image.onerror = () => resolve(null);
  });
  image.src = `assets/textures/${name}.jpg`;
  cache.set(name, p);
  return p;
}

// Runs fn once every named photo has loaded (or failed), if at least one is there.
export function whenPhotos(names, fn) {
  Promise.all(names.map((n) => photo(n).promise)).then((images) => {
    if (images.some(Boolean)) fn();
  });
}

// Fills a rectangle of a canvas with a photo repeated at the right size: `metres` is the real
// width of the photo tile and `pxPerMetre` the scale of the canvas. A CSS filter can grey and
// lighten it so the vertex colours give the hue. Falls back to a flat colour until the photo is
// here. Returns true when the photo was used.
export function paintBase(g, name, x, y, w, h, metres, pxPerMetre, filter, fallback) {
  const p = photo(name);
  if (!p.ready) {
    g.fillStyle = fallback;
    g.fillRect(x, y, w, h);
    return false;
  }
  const pattern = g.createPattern(p.image, 'repeat');
  const k = (metres * pxPerMetre) / p.image.width;
  pattern.setTransform(new DOMMatrix([k, 0, 0, k, x, y]));
  g.save();
  if (filter && 'filter' in g) g.filter = filter;
  g.fillStyle = pattern;
  g.fillRect(x, y, w, h);
  g.restore();
  return true;
}
